import React from 'react';
import { VideoWithStaticImagesDesktop } from './VideoWithStaticImagesDesktop';
import { VideoWithStaticImagesMobile } from './VideoWithStaticImagesMobile';
import {
  ImageStylesProps,
  Wrapper,
  ImagesWrapper,
  StyledCloudImage,
  DisplayAboveMobile,
  DisplayOnMobile,
} from './VideoWithStaticImages.styles';

interface StaticImageProps {
  url: string;
  belowSm: ImageStylesProps;
  sm: ImageStylesProps;
}

export interface VideoWithStaticImagesProps {
  readonly backgroundVideo: string;
  readonly images: StaticImageProps[];
  readonly title: string;
  readonly video: string;
  readonly videoPoster: string;
}

export const VideoWithStaticImages: React.FC<VideoWithStaticImagesProps> = ({ backgroundVideo, images, ...contentProps }) => {
  return (
    <Wrapper marginTop={[9, 0]}>
      <ImagesWrapper>
        {images.map((image, index) => (
          <StyledCloudImage key={index} src={image.url} mobile={image.belowSm} sm={image.sm} />
        ))}
        <DisplayAboveMobile>
          <VideoWithStaticImagesDesktop {...contentProps} backgroundVideo={backgroundVideo} />
        </DisplayAboveMobile>
        <DisplayOnMobile>
          <VideoWithStaticImagesMobile {...contentProps} />
        </DisplayOnMobile>
      </ImagesWrapper>
    </Wrapper>
  );
};
